import { useCallback, useEffect, useState } from 'react'

const STORAGE_KEY = 'autoriz.assistant.collapsed'

export const useCollapsedState = () => {
  // Default to collapsed; user has to opt into the rail. localStorage can
  // override on subsequent visits once they've opened and closed it.
  const [collapsed, setCollapsedState] = useState<boolean>(true)

  useEffect(() => {
    if (typeof window === 'undefined') return
    try {
      const raw = window.localStorage.getItem(STORAGE_KEY)
      if (raw === 'false') setCollapsedState(false)
    } catch {
      // localStorage unavailable — stay collapsed
    }
  }, [])

  const setCollapsed = useCallback((next: boolean) => {
    setCollapsedState(next)
    if (typeof window === 'undefined') return
    try {
      window.localStorage.setItem(STORAGE_KEY, String(next))
    } catch {
      // ignore
    }
  }, [])

  return { collapsed, setCollapsed }
}
